import { render, staticRenderFns } from "./ptspprovinsi.vue?vue&type=template&id=13021de0"
import script from "./ptspprovinsi.vue?vue&type=script&lang=js"
export * from "./ptspprovinsi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports